<template>
<v-container>

    <v-data-table :headers="headers" :items="schedule">
        <template v-slot:[`item.date_time`]="{item}">
            {{ getFormattedDate(item.date_time) }}

        </template>
        <template v-slot:[`item.approve`]="{item}">
            <div v-if="item.approve==1">

                <v-chip color="green white--text">
                    Complete
                </v-chip>

            </div>
            <div v-else>
                <v-chip color="orange white--text ">
                    Watting
                </v-chip>
            </div>

        </template>
        <template v-slot:[`item.log`]="{item}">
            <div v-if="item.log==1">

                <a :href="'https://www.facebook.com/'+item.post_id" target="_blank">
                    <v-chip color="green white--text">
                        View Post
                    </v-chip>
                </a>
            </div>
            <div v-else>
                <div v-if="item.approve ==0">
                        <v-chip color="orange white--text ">
                            Watting
                        </v-chip>
                 </div>
                <v-chip color="red white--text" v-else>
                    <!-- {{ item.log }} -->
             
                
                        {{ extraJson(item.log)  }}
                    

                </v-chip>
            </div>

        </template>

    </v-data-table>
    <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

</v-container>
</template>

<script>
import axios from 'axios'
export default {
    name: 'Viewschedule',
    data: () => ({
        overlay:false,
        userData: [],
        schedule: [],
        headers: [

            {
                sortable: false,
                text: 'Date Schedule',
                value: 'date_time'
            },
            {
                text: 'Status ',
                value: 'approve',
                align: 'center'
            },
            {
                text: 'Logs ',
                value: 'log',
                align: 'center'
            }

        ],

    }),
    mounted() {

  

        this.getViewSche();

    },
    methods: {
        extraJson(data){
            var j=JSON.parse(data)
         
            return j.message
        },
        getFormattedDate(date) {
            return moment(date).format("hh:mm:ss DD-MM-YYYY")
        },
        getViewSche() {

            // this.userData.data.user.id   
            this.overlay= true
            axios.get('https://app.camsmartbiz.com/user/viewschedule/106').then((data) => {
            // axios.get('https://app.camsmartbiz.com/user/viewschedule/'+this.userData.data.user.id).then((data) => {

                this.schedule = data.data.data

            }).catch((err) => {
                this.$swal('Error', "Something Wrong !", 'error');
            }).finally(() => {
                this.overlay=false
            })

        }

    },
    created() {

        this.userData = JSON.parse(localStorage.getItem('info'))

    }
}
</script>
